import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { nanoid } from 'nanoid';
import { Card } from 'component-library-and-tools';

import Checkbox from 'shared/components/Checkbox';
import { colors } from 'lib/prisma-styles';

import { SelectableCardProps } from './types';

const CHECKBOX_LABEL = 'selectable-card__checkbox-label';

const StyledCard = styled(Card)<{ selected: boolean }>`
  && {
    width: 100%;
    padding: 1rem 1.333333333rem;
    background-color: ${({ selected }) => selected ? colors.interactive.selectedActive : colors.interactive.defaultBackground};
  }
`;

const StyledCheckbox = styled(Checkbox)`
  & .${CHECKBOX_LABEL} {
    font-size: 1.166666667rem;
    font-weight: ${({ isChecked }) => isChecked ? 700 : 400};
    cursor: pointer;
  }
`;

const SelectableCard = ({
  className,
  children,
  isSelected = false,
  label = '',
  onSelect = () => {},
}: SelectableCardProps) => {
  const [checkboxId] = useState(nanoid(10));
  const [selectedStatus, setSelectedStatus] = useState(isSelected);

  useEffect(() => {
    setSelectedStatus(isSelected);
  }, [isSelected]);

  const updateSelectedStatus = useCallback(() => {
    const newSelectedStatus = !selectedStatus;

    setSelectedStatus(newSelectedStatus);
    onSelect(newSelectedStatus);
  }, [selectedStatus, onSelect]);

  return (
    <StyledCard
      className={className}
      selected={selectedStatus}
      onClick={updateSelectedStatus}
    >
      <StyledCheckbox
        id={checkboxId}
        isChecked={selectedStatus}
        label={label}
        labelClassName={CHECKBOX_LABEL}
      />
      {children}
    </StyledCard>
  );
};

export default SelectableCard;
